interface Endpoints {
  login: string;
  exams: string;
  user: string;
  categories: string;
  products: string;
  atc: string;
  me: string;
  requestsAtc: string;
  requestsUser: string;
  voucherAtc: string;
  voucherPublic: string;
  announcements: string;
  announcementsAtc: string;
  financesAtc: string;
  financesPublic: string;
  examinstancesSchedule: string;
  userExaminstancesSchedule: string;
  userExaminstancesSubmitted: string;
  examinstances: string;
  atcUsers: string;
  atcExams: string;
  usersAtc: string;
  supportTickets: string;
}

export const EndPoints: Endpoints = {
  login: `/auth/{{oauthToken}}`,
  me: `users/self`,
  exams: "exams",
  categories: "categories",
  products: "products",
  requestsAtc: "requests/atc",
  requestsUser: "requests/user",
  voucherAtc: "vouchers/atc",
  voucherPublic: "vouchers/public",
  announcements: "announcements",
  announcementsAtc: "announcements/atc",
  user: "users",
  financesAtc: "finances/atc",
  financesPublic: "finances/public",
  atc: "atcs",
  examinstances: "examinstances",
  examinstancesSchedule: "examinstances/scheduled",
  userExaminstancesSchedule: "examinstances/user/scheduled",
  userExaminstancesSubmitted: "examinstances/user/submitted",
  atcUsers: "exams/user",
  atcExams: "exams/atc",
  usersAtc: "users/atc",
  supportTickets: "/support/tickets",
};
